import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import BrandLogo from './BrandLogo';

const { FiClock, FiExternalLink, FiMail, FiMapPin, FiPhone, FiStar } = FiIcons;

const services = [
  { name: 'Realizzazione Siti Web', path: '/servizi/realizzazione-siti-web-napoli' },
  { name: 'E-commerce', path: '/servizi/realizzazione-ecommerce-napoli' },
  { name: 'Social Media Manager', path: '/servizi/social-media-manager-napoli' },
  { name: 'Web Marketing', path: '/servizi/web-marketing-napoli' },
  { name: 'Consulenza SEO', path: '/servizi/consulenza-seo-napoli' },
  { name: 'Branding', path: '/servizi/branding-napoli' }
];

const businessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Realizzazione Siti Web Napoli',
  description: 'Web agency specializzata in siti web, e-commerce e marketing digitale a Napoli',
  url: 'https://realizzazionesitiwebnapoli.com',
  telephone: '+39 350 070 3118',
  email: 'info@realizzazionesitiwebnapoli.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Via Toledo 123',
    addressLocality: 'Napoli',
    addressRegion: 'Campania',
    postalCode: '80134',
    addressCountry: 'IT'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '40.8518',
    longitude: '14.2681'
  },
  openingHours: ['Mo-Fr 09:00-18:00', 'Sa 09:00-13:00'],
  sameAs: [
    'https://www.facebook.com/realizzazionesitiweb.napoli',
    'https://www.instagram.com/realizzazionesitiweb.napoli',
    'https://www.linkedin.com/company/realizzazione-siti-web-napoli'
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '120'
  }
};

const Footer = () => (
  <footer className="bg-napoli-dark text-white">
    <div className="container mx-auto px-4 py-12">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
        <div className="space-y-5">
          <BrandLogo light />
          <p className="max-w-sm text-sm leading-relaxed text-gray-200">
            Web agency specializzata in siti web, e-commerce e marketing digitale a Napoli.
            Aiutiamo le aziende locali a crescere online con soluzioni su misura.
          </p>
          <div className="flex items-center gap-3 rounded-xl bg-napoli-blu p-3">
            <div className="flex gap-1" aria-label="Valutazione 4.9 su 5">
              {[...Array(5)].map((_, index) => (
                <SafeIcon key={index} icon={FiStar} className="h-4 w-4 fill-current text-napoli-accent" />
              ))}
            </div>
            <div className="text-sm">
              <div className="font-semibold">4.9/5</div>
              <div className="text-gray-200">120+ recensioni</div>
            </div>
          </div>
        </div>

        <div>
          <h2 className="mb-4 font-poppins text-lg font-bold">Servizi</h2>
          <ul className="space-y-2">
            {services.map((service) => (
              <li key={service.path}>
                <Link
                  to={service.path}
                  className="text-sm font-medium text-gray-200 transition-colors hover:text-napoli-accent"
                >
                  {service.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="mb-4 font-poppins text-lg font-bold">Contatti</h2>
          <div className="space-y-4 text-sm text-gray-200">
            <div className="flex items-start gap-3">
              <SafeIcon icon={FiMapPin} className="mt-0.5 h-5 w-5 flex-shrink-0 text-napoli-accent" />
              <span>Via Toledo 123<br />80134 Napoli (NA)</span>
            </div>
            <a href="tel:+393500703118" className="flex items-center gap-3 hover:text-napoli-accent">
              <SafeIcon icon={FiPhone} className="h-5 w-5 flex-shrink-0 text-napoli-accent" />
              +39 350 070 3118
            </a>
            <a href="mailto:info@realizzazionesitiwebnapoli.com" className="flex items-center gap-3 hover:text-napoli-accent">
              <SafeIcon icon={FiMail} className="h-5 w-5 flex-shrink-0 text-napoli-accent" />
              info@realizzazionesitiwebnapoli.com
            </a>
            <div className="flex items-start gap-3">
              <SafeIcon icon={FiClock} className="mt-0.5 h-5 w-5 flex-shrink-0 text-napoli-accent" />
              <span>Lun-Ven: 9:00-18:00<br />Sab: 9:00-13:00</span>
            </div>
            <a
              href="https://wa.me/393500703118"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 font-semibold text-white transition-colors hover:bg-green-700"
            >
              <span>WhatsApp</span>
              <SafeIcon icon={FiExternalLink} className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div className="border-t border-napoli-blu">
      <div className="container mx-auto flex flex-col items-center justify-between gap-4 px-4 py-6 text-center md:flex-row md:text-left">
        <p className="text-sm text-gray-200">
          © 2024 Realizzazione Siti Web Napoli. Tutti i diritti riservati. | P.IVA: 12345678901
        </p>
        <div className="flex flex-wrap justify-center gap-5 text-sm">
          <Link to="/privacy" className="text-gray-200 transition-colors hover:text-napoli-accent">Privacy Policy</Link>
          <Link to="/cookie" className="text-gray-200 transition-colors hover:text-napoli-accent">Cookie Policy</Link>
          <Link to="/termini" className="text-gray-200 transition-colors hover:text-napoli-accent">Termini di Servizio</Link>
        </div>
      </div>
    </div>

    <script type="application/ld+json">{JSON.stringify(businessSchema)}</script>
  </footer>
);

export default Footer;